<template>
  <div class="gardenmap">
    <header-bar
      :title="title"
      :back-link="backLink"
    />
    <garden-map
      :markers="markers"
      :debug-click="true"
      :tile-source="tileSource"
      @feature-click="popupModal"
    />
    <modal-popup
      ref="modal"
    >
      <h1 slot="header">
        {{ lasttitle }}
      </h1>
      <div slot="body">
        <div v-if="lastimage">
          <img :src="lastimage">
        </div>
        <!-- eslint-disable vue/no-v-html -->
        <div v-html="lasthtml" />
        <!-- eslint-enable -->
      </div>
      <!-- <div slot="footer"><p>The legend</p><button @click="popdownModal">Clooooose</button></div> -->
    </modal-popup>
  </div>
</template>

<script>
import GardenMap from '../components/GardenMap.vue'
import ExhibitData from '../mixins/ExhibitData.vue'
import forOwn from 'lodash/forOwn'
import config from '../config'

import 'ol/ol.css'

export default {
    components: {
        GardenMap
    },
    mixins: [ExhibitData],
    props: {
      exhibitGroup: {
        type: [String,Boolean],
        default: false
      },
      title: {
        type: String,
        default: 'Garden Map'
      },
      backLink: {
        type: [String, Object, Boolean],
        default: false
      }
    },
    data() {
        return {
            lastClicked: null,
            tileSource: config.tileSource
        }
    },
    computed: {
        markers() {
          const markers = []
          if (this.exhibitsLoaded) {
            const exhibits = this.exhibitGroup ? this.$store.getters.exhibitsGrouped[this.exhibitGroup] : this.$store.getters.allExhibits
            forOwn(exhibits, (ex) => {
              if (!ex.longitude || !ex.latitude) {
                return
              }
              markers.push({ longitude: ex.longitude, latitude: ex.latitude, exhibitdata: ex })
            })
          }
          return markers
        },
        lasthtml() {
          return this.lastClicked ? this.lastClicked.data.description : ''
        },
        lastimage() {
          return this.lastClicked ? this.lastClicked.data.image : false
        },
        lasttitle() {
          return this.lastClicked ? this.lastClicked.name : false
        }
    },
    mounted() {
    },
    methods: {
        popupModal(feature) {
            this.lastClicked = feature.get('exhibitdata')
            this.$refs.modal.open()
        },
        popdownModal() {
            this.$refs.modal.close()
        }
    }
}
</script>

<style lang="scss" scoped>
.gardenmap {
    background: black;
    @include flex-vertical;
    /deep/ .map-wrapper {
        background: #a4b56e;
    }
}
</style>